import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import apiInstance from "../../apiInstance";
import PopupModal from "../popups/PopupModal";

const Support = () => {
    const user = useSelector((state) => state.currentUser);
    const [tickets, setTickets] = useState([]);
    const [error, setError] = useState("");
    const popupRef = useRef();
    const navigate = useNavigate();

    const addTicketHandler = (ticket) => {
        setTickets((prev) => [ticket, ...prev]);
    };

    const deleteTicketHandler = (ticketId) => {
        setTickets((prev) => prev.filter((item) => item.id !== ticketId));
    };

    const updateTicketHandler = (ticket) => {
        const updatedTickets = tickets.map((item) =>
            item.id === ticket.id ? { ...item, ...ticket } : item
        );
        setTickets(updatedTickets);
    };

    useEffect(() => {
        const fetchTickets = async () => {
            apiInstance
                .get(`/dashboard/support-ticket`, {
                   params: {
                        user: user.id,
                    },
                })
                .then((response) => {
                    const fetchedTickets = response.data.tickets || [];
                    setTickets(fetchedTickets);
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load tickets.");
                });
        };
        fetchTickets();
    }, [user.id]);

    return (
        <>
            <div className="mjs-dash-section">
                <div className="mjs-dash-sec-header">
                    <h4>Support Tickets</h4>
                    <div>
                        <button
                            className="mjs-btn"
                            onClick={(e) => {
                                if (popupRef.current) {
                                    popupRef.current.openPopup("addTicket");
                                }
                            }}
                        >
                            Create New Ticket
                        </button>
                    </div>
                </div>

                {error && <p className="mjs-error">{error}</p>}

                <table className="mjs-table hover-enabled">
                    <thead>
                        <tr>
                            <th>Ticket ID</th>
                            <th>Subject</th>
                            <th>Category</th>
                            <th>Status</th>                            
                            <th>Date</th>
                            <th></th>
                        </tr>
                    </thead>

                    {tickets.length > 0 ? (
                        <tbody>
                            {tickets.map((ticket) => (
                                <tr 
                                    key={ticket.id}
                                    onClick={() => navigate(`/support/${ticket._id}`)}
                                >
                                    <td>#{ticket.ticket_number || ''}</td>
                                    <td>{ticket.subject || "-"}</td>
                                    <td>{ticket.category || "-"}</td>
                                    <td>{ticket.status || "-"}</td>                                    
                                    <td>
                                        {ticket.createdAt
                                            ? new Date(
                                                  ticket.createdAt
                                              ).toDateString()
                                            : "—"}
                                    </td>
                                    <td className="mjs-table-actions">
                                        <i
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (popupRef.current) {
                                                    popupRef.current.openPopup(
                                                        "editTicket",
                                                        { ticket }
                                                    );
                                                }
                                            }}
                                            title="Edit Ticket"
                                            className="fa-solid fa-pen-to-square"
                                        ></i>
                                        <i
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (popupRef.current) {
                                                    popupRef.current.openPopup(
                                                        "deleteTicket",
                                                        { ticketId: ticket._id }
                                                    );
                                                }
                                            }}
                                            title="Delete Ticket"
                                            className="fa-solid fa-trash"
                                        ></i>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="8" className="mjs-msg">
                                    No tickets found.
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
            <PopupModal
                ref={popupRef}
                addTicket={addTicketHandler}
                deleteTicket={deleteTicketHandler}
                updateTicket={updateTicketHandler}
            />
        </>
    );
};

export default Support;
